import type { RangeKey, WellnessMetric } from "./types";

export const RANGE_OPTIONS: { key: RangeKey; label: string; days: number }[] = [
  { key: "week", label: "Week", days: 7 },
  { key: "month", label: "Month", days: 30 },
  { key: "quarter", label: "12 weeks", days: 84 },
];

export const HISTORY_DAYS = 84;
export const INSIGHT_DAYS = 28;

export const WELLNESS_METRICS: WellnessMetric[] = [
  { key: "sleepHours", label: "Sleep hours", kind: "hours" },
  { key: "sleepQuality", label: "Sleep quality", kind: "rating" },
  { key: "dietQuality", label: "Diet", kind: "rating" },
  { key: "exerciseQuality", label: "Exercise", kind: "rating" },
];
